import React from "react";

const SignatureLogo = () => {
  const sigPath = "M6.46,24.2c-0.98,4.53-2.17,9.03-2.81,13.61c-0.18,1.3,1.11,3.94,1.94,4.03c1.84,0.2,3.85-0.72,5.71-1.41 c0.41-0.15,0.85-1.37,0.66-1.86c-1.87-4.81,1.6-7.51,4.03-10.64c-0.25,3.15-3.96,5.5-2.45,8.99c1.61-0.82,3.02-1.54,4.43-2.26 c-0.12,1.2-0.24,2.39-0.37,3.59c1.45-0.38,2.75-1.24,3.13-2.4c1.45-4.41,2.61-8.91,3.88-13.38c2.49-1.1,3.71-0.68,3.41,2.43 c-0.43,4.55-1.44,8.79-4.13,12.63c-0.96,1.37-1.05,3.35-1.53,5.06c0.27,0.17,0.54,0.34,0.81,0.5c0.92-0.52,2.21-0.8,2.71-1.59 c2.87-4.54,6.01-9.04,5.24-14.89c-0.38-2.86,2.62-7.27,5.55-7.84c0,1.84,0,3.63,0,5.71c0.96,0,1.68-0.02,2.39,0 c4.1,0.14,5.11,1.29,4.53,5.34c-0.21,1.48-0.61,2.93-0.95,4.39c-0.31,1.32-0.65,2.64-1,4.03c4.22-0.84,5.14-2,4.78-5.77 c-0.56-5.86,0.12-11.5,3.48-16.51c0.68-1.01,1.98-1.6,3-2.39c0.61,1.16,1.81,2.37,1.73,3.48c-0.27,3.8-0.82,7.61-1.62,11.33 c-0.43,1.97-1.6,3.78-2.44,5.67c0.3,0.17,0.6,0.35,0.89,0.52c1.49-2.32,3.09-4.59,4.45-6.98c1.93-3.39,3.37-7.12,5.66-10.24 c1.22-1.67,3.74-3.06,5.76-3.18c0.99-0.06,2.19,3.03,3.27,4.72c0.25,0.4,0.37,0.87,0.99,2.39C74.52,17,77,13.34,79.48,9.67 c0.41-0.09,0.82-0.17,1.23-0.26c1.29,8.4,2.25,16.95,9.3,23.13c0.45-2.84,0.9-5.58,1.33-8.33c1.09-6.93,3.53-13.29,8.43-18.42 c1.23-1.29,3.2-1.88,4.83-2.79c0.8,1.85,2.31,3.73,2.23,5.54c-0.13,2.92-1.27,5.81-2.07,8.69c-0.36,1.3-0.96,2.54-1.47,3.89 c2.68,2.33,5.15,4.62,7.77,6.72c4.34,3.49,7.88,2.89,11.07-1.66c0.65-0.92,1.46-1.72,2.6-2.31c0.79,3.2-1.25,5.02-3.19,6.74 c-2.49,2.19-5.58,2.56-8.38,1.08c-2.6-1.37-4.81-3.48-7.17-5.3c-1.17-0.91-2.29-1.89-3.01-2.49c-7.33,4.98-6.46,13.89-10.12,20.58 c-0.42-0.04-0.83-0.09-1.25-0.13c-0.53-3.08-1.06-6.15-1.51-8.77c-1.91-1.39-3.57-2.59-5.33-3.87c-0.39,1.76-0.48,4.04-1.42,5.88 c-0.78,1.51-2.69,3.57-3.89,3.45c-1.7-0.18-3.8-1.82-4.69-3.41c-1.69-3.04-0.31-9.66,2.6-11.28c3.29-1.82,3.04-3.99,2.21-6.76 c-0.24-0.81-0.33-1.66-0.71-3.59c-3.13,5.66-8.98,7.95-10.31,14.08c-0.42,1.96-1.91,3.78-3.18,5.46c-3.8,5.02-7.07,4.72-9.95-0.66 c-4.05,2.11-8.02,4.4-12.18,6.27c-3.09,1.39-4.89-0.26-4.19-3.58c0.7-3.27,1.57-6.5,2.37-9.71c-4.59-1.39-6.02-0.76-7.54,3.04 c-1.02,2.55-1.89,5.17-3.08,7.63c-0.85,1.77-1.82,3.71-3.28,4.91c-1.4,1.14-3.6,2.1-5.26,1.85c-1.13-0.17-1.93-2.54-3.27-4.5 c-2.2-0.46-4.56,0.29-7.18,2.34c-1.77,1.38-5.16,1.48-7.61,1.02c-2.85-0.53-3.16-3.47-3.24-6.08C0.74,30.53,4.19,24.04,6.9,17.37 c0.97-2.39,2.45-4.6,3.9-6.75c0.37-0.55,1.65-0.94,2.29-0.73c0.57,0.19,1.16,1.3,1.17,2.02c0.16,9.08-2.51,17.44-6.68,25.39 c-0.13,0.24-0.61,0.29-1.13,0.52c0-4.69,0-9.19,0-13.69c0.39,2.84,0.77,5.66,1.15,8.49c0.27,0.06,0.55,0.11,0.82,0.17 c1.35-6.15,2.7-12.31,4.05-18.46c-0.44-0.12-0.88-0.24-1.32-0.36C9.59,17.37,8.03,20.79,6.46,24.2z M93.97,20.65 c4.58-0.61,4.7-3.9,4.62-7.37c0.26,1.46,0.07,2.86,0.33,4.17c0.15,0.78,1.01,1.41,1.55,2.11c0.59-0.48,1.47-0.84,1.72-1.46 c1.01-2.53,2.11-5.09,2.63-7.75c0.36-1.85-0.16-3.88-0.31-6.24C99.3,7.35,95.25,13.98,93.97,20.65z M59.25,35.96 c0.55,0.23,1.09,0.47,1.64,0.7c2.13-3.2,4.26-6.39,6.64-9.96c-3.09-0.36-5.13-0.6-7.39-0.87C58.26,29,57.7,32.4,59.25,35.96z M81.67,27.72c-4.7,1.5-4.73,4.76-4.69,7.76c0.02,1.11,1.48,2.21,2.28,3.31c0.52-0.16,1.04-0.31,1.57-0.47 C81.11,34.79,81.39,31.25,81.67,27.72z M66.81,16.57c-2.74,1.57-4.91,3.21-4.22,6.37c0.09,0.43,3.26,0.95,4.24,0.29 C69.69,21.3,67.4,19.02,66.81,16.57z M92.22,40.85c0.32,0.08,0.64,0.16,0.96,0.24c0.97-3.25,1.93-6.49,2.97-9.96 c-1.59-0.19-2.75-0.34-4.43-0.54C91.89,34.2,92.05,37.53,92.22,40.85z M52.64,19.26c-0.52-0.14-1.04-0.28-1.56-0.41 c-0.85,3.49-1.7,6.97-2.56,10.46c0.44,0.12,0.88,0.23,1.32,0.35C50.77,26.18,51.71,22.72,52.64,19.26z M93.41,28.06 c0.36,0.17,0.73,0.35,1.09,0.52c2.86-1.28,3.33-2.52,1.73-6.99C95.29,23.74,94.35,25.9,93.41,28.06z";

  return (
    <>
      <style>{`
        .sig-svg {
          overflow: visible;
          display: block;
        }

        .sig-path {
          fill: #111111;
          stroke: none;
          opacity: 0;
          animation: sig-fadein 0.1s ease 0s forwards;
        }

        [data-theme="dark"] .sig-path {
          fill: #f5df4e;
        }

        .sig-mask-rect {
          animation: sig-wipe 2.8s cubic-bezier(0.22, 1, 0.36, 1) 0.2s forwards;
        }

        @keyframes sig-wipe {
          from { width: 0; }
          to   { width: 130px; }
        }

        @keyframes sig-fadein {
          to { opacity: 1; }
        }
      `}</style>

      <svg
        className="sig-svg"
        viewBox="0 0 130 50"
        width="72"
        height="28"
        aria-label="Carlos R"
        role="img"
      >
        <defs>
          <clipPath id="sig-clip">
            <rect
              className="sig-mask-rect"
              x="0" y="0"
              width="0"
              height="50"
            />
          </clipPath>
        </defs>
        <path
          className="sig-path"
          d={sigPath}
          clipPath="url(#sig-clip)"
        />
      </svg>
    </>
  );
};

export default SignatureLogo;
